//initial redux
import { put, call, takeEvery, fork, all, take, cancel, select } from "redux-saga/effects";
import securityservice from "../../services/security/security";
import * as router from "react-router-redux";
import { types as setuptypes } from "../../boot/setupRedux";

const initialState = {
   loginFailReason: "",
   keepLoggedIn: true,
   isBusy: false,
   isLoggedIn: false,
   currentUsername: "",
   currentDetails: {},

   showForgotPass: false,
   resetPassSuccess: null,

   loaded: false,

   errors: [],
   hasError: false
};

/////////
//types
export const types = {
   ON_LOAD: "screens/login/ON_LOAD",

   LOGIN: "screens/login/LOGIN",
   LOGIN_AD: "screens/login/LOGIN_AD",
   ON_LOGIN: "screens/login/ON_LOGIN",
   ON_LOGIN_FAILED: "screens/login/ON_LOGIN_FAILED",

   LOGOUT: "screens/login/LOGOUT",
   ON_LOGOUT: "screens/login/ON_LOGOUT",
   ON_LOGOUT_FAILED: "screens/login/ON_LOGOUT_FAILED",

   STORE_DETAILS: "screens/login/STORE_DETAILS",
   TOGGLE_KEEP_LOGGED_IN: "screens/login/TOGGLE_KEEP_LOGGED_IN",

   TOGGLE_FORGOT_PASS: "screens/login/TOGGLE_FORGOT_PASS",

   RESET_PASS: "screens/login/RESET_PASS",
   ON_RESET_PASS: "screens/login/ON_RESET_PASS",
   ON_RESET_PASS_FAILED: "screens/login/ON_RESET_PASS_FAILED",

   CLEAR_STATE: "screens/login/CLEAR_STATE"
};

///////////
//reducers
export const reducers = {
   reducer(state = initialState, action) {
      switch (action.type) {
         case types.ON_LOAD:
            return { ...state, loaded: true };

         case types.LOGIN:
            return { ...state, isBusy: true };
         case types.LOGIN_AD:
            return { ...state, isBusy: true };
         case types.ON_LOGIN:
            return {
               ...state,
               isLoggedIn: true,
               currentUsername: action.payload.currentUsername,
               isBusy: false,
               loginFailReason: ""
            };
         case types.ON_LOGIN_FAILED:
            return {
               ...state,
               errors: state.errors.concat(action.payload).slice(-10),
               hasError: true,
               isBusy: false,
               loginFailReason: action.payload.message || action.payload.toString(),
            };

         case types.LOGOUT:
            return { ...state, isBusy: true };
         case types.ON_LOGOUT:
            return {
               ...state,
               isLoggedIn: false,
               currentUsername: action.payload.currentUsername,
               isBusy: false
            };
         case types.ON_LOGOUT_FAILED:
            return {
               ...state,
               errors: state.errors.concat(action.payload).slice(-10),
               hasError: true,
               isBusy: false
            };

         case types.RESET_PASS:
            return { ...state, isBusy: true };
         case types.ON_RESET_PASS:
            return { ...state, isBusy: false, resetPassSuccess: true };
         case types.ON_RESET_PASS_FAILED:
            return {
               ...state,
               errors: state.errors.concat(action.payload).slice(-10),
               hasError: true,
               isBusy: false,
               resetPassSuccess: action.payload
            };

         case types.TOGGLE_FORGOT_PASS:
            return {
               ...state,
               showForgotPass: !state.showForgotPass,
               resetPassSuccess: null
            };

         case types.CHANGE_SCREEEN:
            return { ...state, currentScreen: action.payload.screen };

         case types.STORE_DETAILS:
            return {
               ...state,
               currentDetails: action.payload.data,
               isLoggedIn: true
            };

         case types.TOGGLE_KEEP_LOGGED_IN:
            return { ...state, keepLoggedIn: !state.keepLoggedIn };

         default:
            return state;
      }
   }
};


//////////
//sagas
export const sagas = {
   *rootSaga() {
      yield all([this.onLogout(), this.loginAD(), this.loginFlow(), this.onResetPass()]);
   },

   *onLogout() {
      yield takeEvery(types.ON_LOGOUT, function*({ payload }) {
         yield put(router.push("/"));
      });
   },
   *loginAD() {
       // eslint-disable-next-line no-undef
       yield takeEvery(types.LOGIN_AD, function* ({payload}) {
           try {
               const token = yield call(securityservice.loginAD, payload.token);
               if (token.error) {
                   throw token.error;
               } else {
                   yield call(securityservice.storeBearer, token);
                   yield call(this.initData, false);
                   yield put(actions.onLogin(true, false));
               }
           } catch (error) {
               console.error(error);
               yield put(actions.onLoginFailed(error || {}));
           }
       });
   },
   *loginFlow() {
      while (true) {
         //first check if token exists and is valid.
         const token = yield call(securityservice.checkTokenExists);
         let authTask;
         if (!token) {
            yield put(actions.genericAction(types.CLEAR_STATE, {}));
            //show login page
            yield put(actions.onLoad());

            //if no token, block on login call
            const { payload } = yield take(types.LOGIN);
            //on login send userpass to serv and set authorization accordingly
            //dont block on this. immediatly go to wait logout.
            authTask = yield fork(this.authorize.bind(this), payload.username, payload.password);
         } else {
            //fetch personal detials
            yield fork(this.initData, true);
            yield put(actions.onLogin(true, "user"));
            yield put(actions.onLoad());
         }
         //block on logout or login error.
         const action = yield take([types.LOGOUT, types.ON_LOGIN_FAILED]);
         if (action.type === types.LOGOUT) {
            if (authTask) {
               //cancel auth if its still running.
               yield cancel(authTask);
            }
            yield put(actions.onLogout());
         }
         yield call(this.clearBearer);
         if (action.type === types.LOGOUT) {
            yield put(actions.genericAction(types.CLEAR_STATE, {}));
         }
      }
   },

   //call with fork. dont add to root saga
   *authorize(user, password) {
      try {
         const token = yield call(securityservice.login, user, password);
         if (token instanceof Error) {
            throw token;
         } else {
            yield call(securityservice.storeBearer, token);
            yield call(this.initData, false);
            yield put(actions.onLogin(true, user));
         }
      } catch (error) {
         console.error(error);
         yield put(actions.genericAction(types.ON_LOGIN_FAILED, error || {}));
      }
   },

   *initData(logerror) {
      try {
         const details = yield call(securityservice.getDetails);
         if (details instanceof Error) {
            throw details;
         }
         yield put(actions.storeDetails(details));
      } catch (error) {
         if (logerror) {
            console.error(error);
            yield put(actions.genericAction(types.ON_LOGIN_FAILED, error));
         } else {
            throw error;
         }
      }
   },

   //call with fork. dont add to root saga
   *clearBearer() {
      try {
         yield call(() => securityservice.removeBearer());
      } catch (error) {
         console.log(error);
         yield put(actions.genericAction(types.ON_LOGOUT_FAILED, error));
      }
   },

   *onResetPass() {
      yield takeEvery(types.RESET_PASS, function*({ payload }) {
         let data = yield call(securityservice.ResetPassword, payload.user);
         if (data instanceof Error) {
            console.error(data);
            yield put(actions.genericAction(types.ON_RESET_PASS_FAILED, data));
         } else {
            yield put(actions.onResetPass(data));
         }
      });
   }
};

////////
//actions
export const actions = {
   onLoad() {
      return {
         type: types.ON_LOAD,
         payload: {}
      };
   },

   toggleForgotPass() {
      return {
         type: types.TOGGLE_FORGOT_PASS,
         payload: {}
      };
   },

   resetPass(user) {
      return {
         type: types.RESET_PASS,
         payload: { user }
      };
   },
   onResetPass() {
      return {
         type: types.ON_RESET_PASS,
         payload: {}
      };
   },

   loginAD(token) {
      return {
         type: types.LOGIN_AD,
         payload: {
            token
         }
      };
   },
   login(username, password) {
      return {
         type: types.LOGIN,
         payload: {
            username,
            password
         }
      };
   },
   storeDetails(data) {
      return {
         type: types.STORE_DETAILS,
         payload: { data }
      };
   },
   logout() {
      return {
         type: types.LOGOUT,
         payload: {}
      };
   },
   onLogout() {
      return {
         type: types.ON_LOGOUT,
         payload: {}
      };
   },
   onLogin(success, currentUsername) {
      return {
         type: types.ON_LOGIN,
         payload: {
            isLoggedIn: success,
            currentUsername
         }
      };
   },

   toggleKeepLoggedIn() {
      return {
         type: types.TOGGLE_KEEP_LOGGED_IN,
         payload: {}
      };
   },

   genericAction(type, data) {
      return {
         type,
         payload: data
      };
   }
};



// WEBPACK FOOTER //
// ./src/ui/Login/redux.js